import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, LinkSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { withCode } from "@/lib/useTrackingCode";

const KIND = { shared: "Shared page", buyer: "Buyer's branded page", own: "Buyer's own page" };

const copy = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Link copied");
  } catch {
    toast.error("Couldn't copy. Select the link and copy it by hand.");
  }
};

function LinkRow({ item, url }) {
  return (
    <div className="flex items-center gap-2" data-testid={`mb-link-${item.slug}`}>
      <span className="w-52 shrink-0 hidden sm:block leading-tight">
        <span className="block text-[10px] uppercase tracking-widest">{item.title}</span>
        <span className="block text-[9px] text-zinc-500">{KIND[item.kind]}{item.kind === "own" && item.firm_name ? ` · ${item.firm_name}` : ""}</span>
      </span>
      <span className="flex-1 border border-black bg-zinc-50 px-2 py-1 text-[10.5px] font-mono break-all">{url}</span>
      <button type="button" onClick={() => copy(url)} data-testid={`mb-link-copy-${item.slug}`}
              className="border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white inline-flex items-center gap-1">
        <Copy size={10} weight="bold" /> Copy
      </button>
    </div>
  );
}

export const MediaBuyerLinksCard = ({ code, origin }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (code) api.get("/media-buyer/links").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [code]);
  if (!code) return null;
  return (
    <section className="brut-card bg-white p-4 mb-6" data-testid="mb-links-card">
      <div className="flex items-center gap-2 flex-wrap mb-1">
        <LinkSimple size={18} weight="bold" />
        <div className="font-chivo font-black uppercase tracking-tighter">Your traffic links</div>
        <span className="label-mono">Tracking code</span>
        <span className="border-2 border-black px-2 py-0.5 font-mono text-xs" data-testid="mb-links-code">{code}</span>
      </div>
      <p className="text-[11px] text-zinc-600 mb-3">
        These are the pages you&apos;ve been given. Every lead from these links is credited to you, whichever firm gets it. Add <span className="font-mono">&amp;sub=…</span> to track your ad sources.
      </p>
      {items === null && <div className="label-mono">Loading…</div>}
      {items && items.length === 0 && (
        <div className="text-[12px] text-zinc-700 border border-dashed border-zinc-400 p-3" data-testid="mb-links-empty">
          No pages have been given to you yet. Ask your admin to give you pages to run.
        </div>
      )}
      {items && items.length > 0 && (
        <div className="flex flex-col gap-1.5">
          {items.map((it) => <LinkRow key={it.id} item={it} url={withCode(`${origin}${it.path}`, code)} />)}
        </div>
      )}
    </section>
  );
};
